<template>
    <div class="w-100">
        <div class="row pb-4">

            <div class="col-12 mt-3 addBtn"  @click="editRelationship('contact')" data-toggle="modal" data-target="#relationship">
                <button type="button" class="btn bg-new-primary f-14 h-100">
                    <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_PERSON')}}
                </button>   
            </div>  
            <div class="col-12 dealColumn">
                <div v-if="data!=undefined && data.length>0 && type==='organization'">
                    <div class="m-0 bg-white row pl-3 pr-3 py-3 box-shadow mt-3 font-12 border-radius-4" v-for="(i,index) in data" :key="index">
                        <!--  @click="contactCard(i._id.$oid)"  -->
                        <div class="col-12">
                            <div class="row d-flex justify-content-between cursor-pointer">
                                <div class="name font-13"  @click="contactCard(i._id.$oid)">
                                    <span v-if="i.n!=null">{{i.n}}</span>
                                    <span v-if="i.sn!=null">{{i.sn}}</span>
                                </div>
                                <div class="d-flex align-items-center">
                                <div class="city border border-secondary px-2" v-if="i.city!=null">
                                    {{i.city}}
                                </div>
                                <button type="button" class="btn btn-link" @click="getContactData(i,index)">
                                     <i class="fa fa-edit color-gray f-20 cursor-pointer hover-color-primary ml-2 "></i>
                                </button>
                                </div>
                            </div>
                            <div class="row mt-1" v-if="i.jobTitle!=null">
                                <span>{{i.jobTitle}}</span>
                            </div>
                            <div class="row mt-2">
                                <div v-if="i.sector!=null">
                                    {{i.sector}}
                                </div>
                            </div>
                            <div class="row mt-2">
                                    <span v-if="organization.name!=null" class="col-md-5 p-0">{{organization.name}}</span>
                                    <span v-if="i.email!=null" class="col-7 col-md-4 p-0 f-11 text-truncate"><i class="fa fa-envelope-o mr-1"></i>{{checkIfArray(i.email)}}</span>
                                    <div class="col-5 col-md-3 p-0 d-flex justify-content-end f-11" v-if="i.gsm!=null && i.gsm!=''"><span><i class="fa fa-phone mr-1"></i>{{ checkIfArray(i.gsm) }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div role="alert" class="alert alert-secondary alert-dismissible fade show mt-3">
                        {{$ml.get('NO_RELATED_CONTACTS')}}
                    </div>
                </div>
            </div>
            
        </div>

        <div class="modal fade" id="addContact" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
                <div class="modal-content mcBgGrey" style="max-height:100%; position:fixed; overflow:hidden auto">
                    <div class="modal-header pt-0 border-0 pb-0 align-items-center px-4">
                        <!-- <h5 class="modal-title" id="exampleModalLongTitle">{{this.listenStateStatus?$ml.get("EDIT_PERSON"):$ml.get("ADD_PERSON")}}</h5>
                        <button type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button> -->
                      </div>
                    <div class="modal-body p-0">
                        <newContact :isEditMode="isEditMode" :data="contactData" @getContact="updateContact($event)"  :user="this.user" :users="this.users" @getData="addContact($event)" :customFieldArray="customFields"></newContact>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import newContact from './newContact.vue'
import CountrySelect from '@/components/country-select'
import RegionSelect from '@/components/region-select'

export default {
    name: 'contactList',
    components:{
        CountrySelect,
        RegionSelect,
        "newContact":newContact
    },
    data () {
        return {
            selected:undefined,
            addPhoneText:"",
            addEmailText:"",
            addFaxText:"",
            updateEmailText:"",
            show:true,
            dataId:"",
            isContact:false,
            add:[],
            city:"",
            country:"",
            isTurkeyCountry:false,
            customFields:[],
            isEditMode:false,
            contactData:""

        }
    },
    computed: {
        ...mapState([
            'baseUrl',
            'cityList',
            'townList'
        ]),
        listenStateStatus() { return this.$store.state.editLineStatu },
    },
    props:["data","type","field","user","users","permission","organization"],
    methods:{
        contactCard(id){
            if(id!==""){
                localStorage.contactId=id
                this.updateContactId(id)
                window.open('/contactCard/'+id, '_blank');
            }
        },
        checkIfArray(data){
            let array = [];
            if(data==undefined){
                return array;
            }
            if(!Array.isArray(data)){
                array.push(data);
            
              return array;
            } 
                return data
        },
        ...mapActions([
            'editRelationship',
            'updateLoading',
            'updateContactId'
        ]),
        getContactData(contactId,index){
            this.isEditMode=true
            // this.contactData = this.contactsRow.find(item => item._id.$oid === contactId);
            this.contactData = contactId;
            $('#addContact').modal('show')
        },
        updateContact(data){
            console.log(data);
        },
        addContact(data){
            console.log(data);
        }
    },
    created(){
        this.$root.$refs.contactList = this
    },
    watch:{
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iptal:before{
    color:red
}
.updateInput{
    border: 0px;
    border-bottom: 1px solid #66D0FF80;
}
.add{
    color: #3767a0;
}
.add,.edit:hover{
    cursor: pointer;
}
.add:hover:after{
    content: "\e952";
    font-size: 14px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #66D0FF;
}
.edit:hover:after{
    content: "\e913";
    font-size: 14px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #66D0FF;
}

</style>
